import React from 'react';
import PropTypes from 'prop-types';
// Layout
import Micro from '../../../layouts/Micro';
// Utils
import generateUUID from '../../../utils/generateUUID';
// Components
import TagListItem from '../TagListItem/TagListItem';

const TagList = ({ allTags }) => (
  <Micro>
    <div className="container my-1">
      <div className="row flex-center text-center my-1">
        {allTags.map((tag) => (
          <div className="col-lg-2 col-md-2 col-sm-3 col-xs-6" key={generateUUID()}>
            <TagListItem url={tag.uri} fieldValue={tag.name} />
          </div>
        ))}
      </div>
    </div>
  </Micro>
);

TagList.propTypes = {
  allTags: PropTypes.object.isRequired, // eslint-disable-line
};

export default TagList;
